export enum AccountEntityType {
  COUNTERPARTY = "COUNTERPARTY",
  EXPENSE_ACCOUNT = "EXPENSE_ACCOUNT",
  BANK_ACCOUNT = "BANK_ACCOUNT",
}
